export default {
    orderHistoryItems: [
    ],
    savedOrder: null,
    retailOrderDetails: null,
    specialGoodOrderDetails: {},
    retailHistory: [],
    deliveryPrice: null,
    reorderItems: JSON.parse(localStorage.getItem('reorderItems')) || []
}
